function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { radius, spacing, fontStyle, breakpoints, themeLight } from '@naf/theme';
import { Text, TextVariant } from '@naf/text';
import { Label, MemberLabel } from '@naf/label';
export const CardGrid = ({
  advancedImage,
  img,
  title,
  headerTag = 'h3',
  date,
  href,
  children,
  label,
  cardRef,
  className,
  memberLabel,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Card, _extends({
    as: href ? 'a' : 'div',
    href: href,
    className: className,
    ref: cardRef
  }, rest), /*#__PURE__*/React.createElement(Figure, null, label && /*#__PURE__*/React.createElement(CardLabel, {
    text: label.text,
    size: label.size,
    variant: label.variant
  }), memberLabel && /*#__PURE__*/React.createElement(ExclusiveLabel, memberLabel), (advancedImage || img) && /*#__PURE__*/React.createElement(ImgWrap, null, advancedImage && advancedImage, img && !advancedImage && /*#__PURE__*/React.createElement("img", {
    src: img.src,
    alt: img.alt
  }))), /*#__PURE__*/React.createElement(Content, null, date && /*#__PURE__*/React.createElement(Date, null, date), /*#__PURE__*/React.createElement(Header, {
    tag: headerTag,
    variant: TextVariant.CardHeader
  }, /*#__PURE__*/React.createElement(HoverWrap, null, title)), /*#__PURE__*/React.createElement(Body, null, children)));
};
export default CardGrid;
const HoverWrap = styled.span.withConfig({
  displayName: "card-grid__HoverWrap",
  componentId: "sc-1l8fgse-0"
})(["background-size:0 2px;background-position:0 100%;background-image:linear-gradient( 90deg,", ",", " );background-repeat:no-repeat;transition:background-size 0.3s ease;text-decoration:none;display:inline;"], ({
  theme
}) => theme.componentColors ? theme.componentColors.interactiveElement.active : themeLight.componentColors.interactiveElement.active, ({
  theme
}) => theme.componentColors ? theme.componentColors.interactiveElement.active : themeLight.componentColors.interactiveElement.active);
const Card = styled.a.withConfig({
  displayName: "card-grid__Card",
  componentId: "sc-1l8fgse-1"
})(["display:flex;flex-wrap:wrap;text-decoration:none;", ";color:", ";overflow-x:auto;padding-top:", ";margin-top:-", ";&:visited,&:hover,&:active{color:", ";}&:hover{img{transform:scale(1.02);}", "{background-size:100% 2px;}}@media (max-width:", "){margin-bottom:", ";}"], fontStyle.bodyText.bodyText, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText, spacing.space8, spacing.space8, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText, HoverWrap, breakpoints.s, spacing.space48);
const ImgWrap = styled.div.withConfig({
  displayName: "card-grid__ImgWrap",
  componentId: "sc-1l8fgse-2"
})(["position:relative;width:100%;max-height:100%;padding:0;margin:0;overflow:hidden;flex:none;border-radius:", ";&:before{display:block;content:'';padding-top:56.25%;}&:after{content:'';position:absolute;top:0;right:0;bottom:0;left:0;background:radial-gradient( 140.28% 84.01% at 54.18% 20.35%,rgba(0,0,0,0) 49%,rgba(0,0,0,0.08) 64%,rgba(0,0,0,0.61) 100% ),radial-gradient(218.33% 124.37% at 64.41% 0%,rgba(0,0,0,0) 47%,rgba(0,0,0,0.48) 100%);z-index:1;}img{position:absolute;top:0;left:0;height:100%;width:100%;object-fit:cover;transition:transform 0.6s ease;z-index:1;}"], radius.s);
const Figure = styled.div.withConfig({
  displayName: "card-grid__Figure",
  componentId: "sc-1l8fgse-3"
})(["position:relative;width:100%;max-height:100%;"]);
const CardLabel = styled(Label).withConfig({
  displayName: "card-grid__CardLabel",
  componentId: "sc-1l8fgse-4"
})(["position:absolute;top:-", ";right:", ";z-index:2;"], spacing.space8, spacing.space12);
const ExclusiveLabel = styled(MemberLabel).withConfig({
  displayName: "card-grid__ExclusiveLabel",
  componentId: "sc-1l8fgse-5"
})(["position:absolute;bottom:", ";left:", ";z-index:2;"], spacing.space8, spacing.space8);
const Content = styled.div.withConfig({
  displayName: "card-grid__Content",
  componentId: "sc-1l8fgse-6"
})(["display:flex;flex-wrap:wrap;align-content:flex-start;"]);
const Date = styled.div.withConfig({
  displayName: "card-grid__Date",
  componentId: "sc-1l8fgse-7"
})(["margin-top:", ";flex-basis:100%;&:after{content:'';display:block;width:", ";padding-top:", ";border-bottom:2px solid;border-color:", ";}"], spacing.space16, spacing.space16, spacing.space12, ({
  theme
}) => theme.componentColors ? theme.componentColors.extras.accent : themeLight.componentColors.extras.accent);
const Header = styled(Text).withConfig({
  displayName: "card-grid__Header",
  componentId: "sc-1l8fgse-8"
})(["margin:", " 0 ", ";@media (max-width:", "){margin-top:", ";font-size:1.375rem;}"], spacing.space24, spacing.space16, breakpoints.s, spacing.space16);
const Body = styled.span.withConfig({
  displayName: "card-grid__Body",
  componentId: "sc-1l8fgse-9"
})(["flex-basis:100%;"]);
//# sourceMappingURL=card-grid.js.map